export const REVIEW_MAX_RATING = 5;
export const REVIEW_MIN_RATING = 0.5;
